import { Component } from "@angular/core";
import { BaseComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-checklisttemplate-main",
    templateUrl: "./checklisttemplate.main.component.html",
    standalone: false
})
export class ChecklistTemplateMainComponent extends BaseComponent {}
